import React, { useEffect, useState } from "react";
import {
  CommonMFE,
  Helpers,
  MFE_NAMES,
  Providers,
  ReactMFE,
} from "@tpd-web-common-libs/nodejs-library";
import {
  ContainerDiv,
  TpdGoBack,
  TpdTastoIndietroContainer,
  TpdTastoIndietroContent,
} from "./App.style";
import styled from "@emotion/styled";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

enum OFFSET {
  MEDIUM_OFFSET = "medium offset",
  SMALL_OFFSET = "small offset",
}

const App = (props: CommonMFE.Types.TRemoteProps) => {
  const { __host__, config, isEditMode, id: containerID, __mfeName__ } = props;

  const [goBack, setGoBack] = useState(false);
  const tpdShortText = config["Testo Link"];
  const tpdTastoIndietrOffset = config["offset"] && config["offset"].value;
  const offset = Helpers.RemoteHelper.getSelectedValue(tpdTastoIndietrOffset).length === 0 ? OFFSET.MEDIUM_OFFSET : Helpers.RemoteHelper.getSelectedValue(tpdTastoIndietrOffset);
  const routingService = new Providers.RouterService();

  const onClickGoBack = () => (!isEditMode ? routingService.goBack() : null);

  useEffect(() => {
    if (
      Helpers.EnvironmentHelper.isClientSide() &&
      window &&
      window.history &&
      window.history.length >= 2
    ) {
      setGoBack(true);
    }
  });

  return (
    <>
      {(tpdShortText?.value?.value != "" || isEditMode) && (
        <ContainerDiv
          goBack={goBack}
          textLink={tpdShortText.value.value}
          isEditmode={isEditMode}
        >
          <TpdTastoIndietroContainer>
            <TpdTastoIndietroContent offset={offset}>
              <div className="tpd-icon icon-Freccia-sx iconfont"></div>
              <TpdGoBack data-testid="go-back" onClick={onClickGoBack}>
                <ReactMFE.Remote
                  id={CommonMFE.generateID(
                    containerID,
                    `${MFE_NAMES.tpdTastoIndeitro}-${MFE_NAMES.tpdShortText}`
                  )}
                  __deps__={React}
                  __host__={__host__}
                  __mfeName__={MFE_NAMES.tpdShortText}
                  isEditMode={isEditMode}
                  {...tpdShortText}
                />
              </TpdGoBack>
            </TpdTastoIndietroContent>
          </TpdTastoIndietroContainer>
        </ContainerDiv>
      )}
    </>
  );
};

export default ReactMFE.PrimaryRemoteHOCFactory(
  React,
  styled,
  { CacheProvider },
  createCache
)(App);
